import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Controller, useFormContext } from 'react-hook-form';
import dayjs from 'dayjs';

const CustomDatePicker = ({
  name,
  label,
  format = 'MM/DD/YYYY',
  minDate,
  maxDate,
  disabled,
  value,
  onChange,
}) => {
  const formContext = useFormContext();
  const control = formContext?.control;
  const errors = formContext?.formState?.errors;

  const error = name ? errors?.[name]?.message : undefined;

  if (!name) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label={label}
          format={format}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          value={value ? dayjs(value) : null}
          onChange={onChange}
        />
      </LocalizationProvider>
    );
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Controller
        name={name}
        control={control}
        defaultValue={null}
        render={({ field }) => (
          <DatePicker
            {...field}
            label={label}
            format={format}
            minDate={minDate}
            maxDate={maxDate}
            disabled={disabled}
            value={field.value ? dayjs(field.value) : null}
            slotProps={{
              textField: {
                fullWidth: true,
                error: !!error,
                helperText: error,
              },
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;
